module.exports = __webpack_public_path__ + "img/nexo-cordoba.ac2dacd2.jpg";